import React, { memo } from 'react';
import { LineItemCardTypeTokens, } from '@voltmoney/schema';
import LineItemCardBase from './LineItemCard.base';
import ThemeProvider from '@voltmoney/theme';
/**
 * Primary UI component for user interaction
 */
const LineItemCard = ({ type = LineItemCardTypeTokens.DEFAULT, ...props }) => {
    const theme = ThemeProvider.getTheme();
    const lineThemeProps = theme.lineItemCard[type];
    switch (type) {
        case LineItemCardTypeTokens.DEFAULT:
            return (React.createElement(LineItemCardBase, { ...lineThemeProps, ...props }));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default memo(LineItemCard);
export { LineItemCard };
